export const DEVICE_TYPES = [
    {id: 'tv', name: 'TV'},
    {id: 'laptop', name: 'Laptop'},
    {id: 'desktop', name: 'Escritorio'},
    {id: 'tablet', name: 'Tablet'},
    {id: 'mobile', name: 'Móvil'},
    {id: 'other', name: 'Otro'},
];

export const DEVICE_LOCATIONS = [
    {id: 'living_room', name: 'Sala de estar'},
    {id: 'bedroom', name: 'Dormitorio'},
    {id: 'kitchen', name: 'Cocina'},
    {id: 'office', name: 'Oficina'},
    {id: 'dining_room', name: 'Comedor'},
    {id: 'other', name: 'Otro'},
]

export const getDeviceType = (id: string) => {
    const type = DEVICE_TYPES.find(t => t.id === id);
    return type ? type.name : 'Otro';
}

export const getDeviceLocation = (id: string) => {
    const location = DEVICE_LOCATIONS.find(l => l.id === id);
    return location ? location.name : 'Otro';
}

export const getDeviceIcon = (id: string): string => {
    switch (id) {
        case 'tv':
            return 'fa-solid fa-tv';
        case 'laptop':
            return 'fa-solid fa-laptop';
        case 'desktop':
            return 'fa-solid fa-computer';
        case 'tablet':
            return 'fa-solid fa-tablet-screen-button';
        case 'mobile':
            return 'fa-solid fa-mobile-screen-button';
        default:
            return 'fa-solid fa-tv';
    }
}
